import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomButtonComponent } from '../custom-button';

export interface TermsModalConfig {
  showAcceptButton?: boolean;
}

@Component({
  selector: 'app-terms-and-conditions-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    CustomButtonComponent
  ],
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.scss']
})
export class TermsAndConditionsModalComponent {
  isAcceptEnabled = false;
  showAcceptButton: boolean;

  constructor(
    private dialogRef: MatDialogRef<TermsAndConditionsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TermsModalConfig
  ) {
    this.showAcceptButton = data?.showAcceptButton ?? true;
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    const threshold = 5;
    const atBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - threshold;
    
    if (atBottom && !this.isAcceptEnabled) {
      this.isAcceptEnabled = true;
    }
  }

  onAccept(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
